import { render, staticRenderFns } from "./CreateExperimentTicket.vue?vue&type=template&id=36f50c4b&scoped=true"
import script from "./CreateExperimentTicket.vue?vue&type=script&lang=js"
export * from "./CreateExperimentTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateExperimentTicket.vue?vue&type=style&index=0&id=36f50c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f50c4b",
  null
  
)

export default component.exports